import { call, put, takeLatest } from "redux-saga/effects";
import request from "../../api/request";

function* getAllProducts(payload) {
  try {
    yield put({
      type: "SHOW_LOADING",
    });

    yield put({
      type: "FETCH_PRODUCTS_REQUESTING",
    });

    const baseUrl = `${process.env.REACT_APP_API_URL}/api/v1/products`;

    const params = new URLSearchParams();

    params.append("page", String(payload.value.page));
    params.append("offset", String(payload.value.offset));

    if (payload.value?.search) {
      params.append("search", payload.value.search);
    }

    if (payload.value?.isActive !== undefined) {
      params.append("isActive", String(payload.value.isActive));
    }

    if (payload.value?.idCompany) {
      params.append("idCompany", String(payload.value.idCompany));
    }

    if (payload.value?.shippersSelected?.length) {
      payload.value.shippersSelected.forEach((shipper) =>
        params.append("shipperIds", shipper),
      );
    }

    if (payload.value?.categoriesSelected?.length) {
      payload.value.categoriesSelected.forEach((category) =>
        params.append("categoryIds", category),
      );
    }

    if (payload.value?.subCategoriesSelected?.length) {
      payload.value.subCategoriesSelected.forEach((subCategory) =>
        params.append("subCategoryIds", subCategory),
      );
    }

    const requestURL = `${baseUrl}?${params.toString()}`;

    const headers = {
      method: "GET",
      headers: new Headers({
        Authorization: `Bearer ${window.localStorage.getItem("token")}`,
        "Content-Type": "application/json",
      }),
    };
    const response = yield call(request, requestURL, headers);

    yield put({
      type: "FETCH_PRODUCT_SUCCESS",
      value: response,
    });
  } catch (error) {
    yield put({
      type: "SHOW_ALERT",
      value: {
        type: "danger",
        title: "Failed load",
        message: "Failed load products",
      },
    });
    yield put({
      type: "FETCH_PRODUCT_ERROR",
    });
  } finally {
    yield put({
      type: "HIDE_LOADING",
    });
  }
}

function* postProduct(payload) {
  try {
    yield put({ type: "CREATE_PRODUCT_REQUESTING" });

    yield put({
      type: "SHOW_LOADING",
    });

    const requestURL = `${process.env.REACT_APP_API_URL}/api/v1/products`;

    const formData = preparePayloadProduct({ ...payload.value, isActive: true });

    const headers = {
      method: "POST",
      headers: new Headers({
        Authorization: `Bearer ${window.localStorage.getItem("token")}`,
      }),
      body: formData,
    };

    const response = yield call(request, requestURL, headers);

    yield put({
      type: "CREATE_PRODUCT_SUCCESS",
      value: response,
    });

    yield put({
      type: "SHOW_ALERT",
      value: {
        type: "success",
        title: "Creación exitosa",
        message: "Se ha creado el producto correctamente",
      },
    });
  } catch (error) {
    yield put({
      type: "CREATE_PRODUCT_ERROR",
      value: error,
    });

    yield put({
      type: "SHOW_ALERT",
      value: {
        type: "danger",
        title: "Error al guardar el producto",
        message: error?.message || "Error al guardar el producto",
      },
    });
  } finally {
    yield put({
      type: "HIDE_LOADING",
    });
  }
}

function* getProductById(payload) {
  try {
    yield put({
      type: "READ_PRODUCT_REQUESTING",
    });
    yield put({
      type: "SHOW_LOADING",
    });
    const requestURL = `${process.env.REACT_APP_API_URL}/api/v1/products/${payload.value.id}`;

    const headers = {
      method: "GET",
      headers: new Headers({
        Authorization: `Bearer ${window.localStorage.getItem("token")}`,
        "Content-Type": "application/json",
      }),
    };
    const response = yield call(request, requestURL, headers);

    yield put({
      type: "HIDE_LOADING",
    });

    yield put({
      type: "READ_PRODUCT_SUCCESS",
      value: response,
    });
  } catch (error) {
    yield put({
      type: "HIDE_LOADING",
    });
    yield put({
      type: "READ_PRODUCT_ERROR",
    });
  }
}

function* deleteProductById(payload) {
  try {
    yield put({
      type: "DELETE_PRODUCT_REQUESTING",
    });
    yield put({
      type: "SHOW_LOADING",
    });
    const requestURL = `${process.env.REACT_APP_API_URL}/api/v1/products/changeState/${payload.value.idProduct}`;

    const headers = {
      method: "PATCH",
      headers: new Headers({
        Authorization: `Bearer ${window.localStorage.getItem("token")}`,
        "Content-Type": "application/json",
      }),
      body: JSON.stringify(payload.value),
    };

    const response = yield call(request, requestURL, headers);

    yield put({
      type: "HIDE_LOADING",
    });

    yield put({
      type: "SHOW_ALERT",
      value: {
        type: "success",
        title: payload.value.isActive === false ? "Successful enable" : "Successful disable",
        message: payload.value.isActive === false
          ? "Successful enable product"
          : "Successful disable product",
      },
    });

    yield put({
      type: "DELETE_PRODUCT_SUCCESS",
      value: response,
    });
  } catch (error) {
    yield put({
      type: "HIDE_LOADING",
    });
    yield put({
      type: "SHOW_ALERT",
      value: {
        type: "danger",
        title: "Failed disable",
        message: "Failed disable product",
      },
    });
    yield put({
      type: "DELETE_PRODUCT_ERROR",
    });
  }
}

function* updateProduct(payload) {
  try {
    yield put({
      type: "UPDATE_PRODUCT_REQUESTING",
    });

    yield put({
      type: "SHOW_LOADING",
    });

    const requestURL = `${process.env.REACT_APP_API_URL}/api/v1/products/${payload.value.id}`;

    const formData = preparePayloadProduct(payload.value);

    const headers = {
      method: "PATCH",
      headers: new Headers({
        Authorization: `Bearer ${window.localStorage.getItem("token")}`,
      }),
      body: formData,
    };

    const response = yield call(request, requestURL, headers);

    yield put({
      type: "UPDATE_PRODUCT_SUCCESS",
      value: response,
    });

    yield put({
      type: "UPDATE_PRODUCT_SUCCESS",
      value: response,
    });
    
    yield put({
      type: "SHOW_ALERT",
      value: {
        type: "success",
        title: "Actualización exitosa",
        message: "Se ha actualizado el producto correctamente",
      },
    });
  } catch (error) {
    yield put({
      type: "UPDATE_PRODUCT_ERROR",
      value: error,
    });
  } finally {
    yield put({
      type: "HIDE_LOADING",
    });
  }
}

function preparePayloadProduct(body) {
  const formData = new FormData();

  if (body?.imageProduct) {
    formData.append("file", body.imageProduct?.[0]);
  }

  if (body?.idProduct) {
    formData.append("id", body.idProduct);
  }

  formData.append("idCountry", body.countryId);
  formData.append("idCompany", body.shipperId);
  formData.append("idCategory", body.categoryId);
  formData.append("idSubCategory", body.subCategoryId);
  formData.append("name", body.productName);
  formData.append("description", body.productDescription);
  formData.append("isActive", body.isActive);
  formData.append("presentation", body.presentation);
  formData.append("abbreviation", body.abbreviation);
  formData.append("productDescription", body.productDescription);
  formData.append("sku", body.sku);
  formData.append("barcode", body.barcode);
  formData.append("masterSku", body.masterSku);
  if (body.unitWeight) formData.append("unitWeight", body.unitWeight);
  formData.append("weight", body.weight);
  if (body.unitDimensions) formData.append("unitDimensions", body.unitDimensions);
  formData.append("width", body.width);
  formData.append("height", body.height);
  formData.append("length", body.length);
  formData.append("receiptUnitMeasure", body.receiptUnitMeasure);
  formData.append("dispatchUnitMeasure", body.dispatchUnitMeasure);
  formData.append("pricePerUnit", body.pricePerUnit);
  formData.append("price", body.price);
  formData.append("shelfLifeDays", body.shelfLifeDays);
  formData.append("maxDispatchDays", body.maxDispatchDays);
  formData.append("image", body.image);

  return formData;
}

function* deleteSoftProductById(payload) {
  try {
    yield put({
      type: "DELETE_SOFT_PRODUCT_REQUESTING",
    });
    yield put({
      type: "SHOW_LOADING",
    });
    const requestURL = `${process.env.REACT_APP_API_URL}/api/v1/products/deleteSoft/${payload.value.idProduct}`;

    const headers = {
      method: "PATCH",
      headers: new Headers({
        Authorization: `Bearer ${window.localStorage.getItem("token")}`,
        "Content-Type": "application/json",
      }),
      body: JSON.stringify(payload.value),
    };

    const response = yield call(request, requestURL, headers);

    yield put({
      type: "DELETE_SOFT_PRODUCT_SUCCESS",
      value: response,
    });
    yield put({
      type: "HIDE_LOADING",
    });

    if (response.message) {
      yield put({
        type: "SHOW_ALERT",
        value: {
          type: "danger",
          title: "Failed delete soft",
          message: response.message,
        },
      });
    } else {
      yield put({
        type: "SHOW_ALERT",
        value: {
          type: "success",
          title: "Successful delete soft",
          message: "Successful delete soft product",
        },
      });
    }
  } catch (error) {
    yield put({
      type: "HIDE_LOADING",
    });
    yield put({
      type: "SHOW_ALERT",
      value: {
        type: "danger",
        title: "Failed delete soft",
        message: "Failed delete soft product",
      },
    });
    yield put({
      type: "DELETE_SOFT_PRODUCT_ERROR",
    });
  }
}

function* downloadAllProducts(payload) {
  try {
    yield put({
      type: "SHOW_LOADING",
    });

    yield put({
      type: "FETCH_DOWNLOAD_PRODUCTS_REQUESTING",
    });

    const requestURL = `${process.env.REACT_APP_API_URL}/api/v1/products/download`;
    const token = window.localStorage.getItem("token");
    const requestData = {
      search: decodeURIComponent(payload.value.search),
      isActive: payload.value.isActive,
      shipperIds: payload.value?.shipperIds || [],
      categoryIds: payload.value?.categoryIds || [],
      subCategoryIds: payload.value?.subCategoryIds || [],
    };

    const response = yield call(fetch, requestURL, {
      method: "POST",
      body: JSON.stringify(requestData),
      headers: new Headers({
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      }),
    });

    if (response.ok) {
      const blob = yield response.blob();
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = `${new Date().toISOString().split('T')[0]}-products.csv`;
      document.body.appendChild(a);
      a.click();
      a.remove();
    } else {
      throw new Error();
    }

    yield put({
      type: "FETCH_DOWNLOAD_PRODUCT_SUCCESS",
    });
  } catch (error) {
    yield put({
      type: "SHOW_ALERT",
      value: {
        type: "danger",
        title: "Failed download",
        message: "Failed download products",
      },
    });
    yield put({
      type: "FETCH_DOWNLOAD_PRODUCT_ERROR",
    });
  } finally {
    yield put({
      type: "HIDE_LOADING",
    });
  }
}

function* connectShopifyProduct(payload) {
  try {
    yield put({
      type: "SHOW_LOADING",
    });

    yield put({
      type: "PUBLISH_SHOPIFY_REQUESTING",
    });

    let requestURL = `${process.env.REACT_APP_API_URL}/api/v1/shopify/products/connectShopify`;
    if (payload.value.action === "disconnect") {
      requestURL = `${process.env.REACT_APP_API_URL}/api/v1/shopify/products/disconnectShopify`;
    }
    const token = window.localStorage.getItem("token");
    const requestData = {
      idProduct: payload.value.idProduct,
    };

    const response = yield call(request, requestURL, {
      method: "POST",
      body: JSON.stringify(requestData),
      headers: new Headers({
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      }),
    });
    if (response.ok) {
      yield put({
        type: "PUBLISH_SHOPIFY_SUCCESS",
      });
    } else {
      throw new Error(response?.message);
    }
  } catch (error) {
    console.log(error.message)
    yield put({
      type: "SHOW_ALERT",
      value: {
        type: "danger",
        title: "Failed publish",
        message: error.message,
      },
    });
    yield put({
      type: "PUBLISH_SHOPIFY_ERROR",
      value: error.message,
    });
  } finally {
    yield put({
      type: "HIDE_LOADING",
    });
  }
}

function* getProductByIdShipper(payload) {
  try {
    yield put({
      type: "FETCH_PRODUCTS_BY_SHIPPER_REQUESTING",
    });
    yield put({
      type: "SHOW_LOADING",
    });
    const requestURL = `${process.env.REACT_APP_API_URL}/api/v1/products/getByIdShipper/${payload.value.id}`;

    const headers = {
      method: "GET",
      headers: new Headers({
        Authorization: `Bearer ${window.localStorage.getItem("token")}`,
        "Content-Type": "application/json",
      }),
    };
    const response = yield call(request, requestURL, headers);

    yield put({
      type: "HIDE_LOADING",
    });

    yield put({
      type: "FETCH_PRODUCTS_BY_SHIPPER_SUCCESS",
      value: response,
    });
  } catch (error) {
    yield put({
      type: "HIDE_LOADING",
    });
    yield put({
      type: "FETCH_PRODUCTS_BY_SHIPPER_ERROR",
    });
  }
}

function* uploadMassiveProductsFile(payload) {
  try {
    yield put({ type: "UPLOAD_MASSIVE_PRODUCTS_FILE_REQUESTING" });

    yield put({
      type: "SHOW_LOADING",
    });

    const requestURL = `${process.env.REACT_APP_API_URL}/api/v1/products/uploadMassive`;

    const formData = new FormData();
    formData.append("file", payload.value.file);
    formData.append("idShipper", payload.value.idShipper);

    const headers = {
      method: "POST",
      headers: new Headers({
        Authorization: `Bearer ${window.localStorage.getItem("token")}`,
      }),
      body: formData,
    };

    const response = yield call(request, requestURL, headers);

    yield put({
      type: "UPLOAD_MASSIVE_PRODUCTS_FILE_SUCCESS",
      value: response,
    });

  } catch (error) {
    console.log(error);
    yield put({
      type: "UPLOAD_MASSIVE_PRODUCTS_FILE_ERROR",
    });

    if (payload.value.onError && typeof payload.value.onError === "function") {
      payload.value.onError(error);
    }
  } finally {
    yield put({
      type: "HIDE_LOADING",
    });
  }
}


export function* watchProduct() {
  yield takeLatest("FETCH_PRODUCTS_REQUEST", getAllProducts);
  yield takeLatest("DOWNLOAD_PRODUCTS_REQUEST", downloadAllProducts);
  yield takeLatest("CREATE_PRODUCT_REQUEST", postProduct);
  yield takeLatest("READ_PRODUCT_REQUEST", getProductById);
  yield takeLatest("DELETE_PRODUCT_REQUEST", deleteProductById);
  yield takeLatest("UPDATE_PRODUCT_REQUEST", updateProduct);
  yield takeLatest("DELETE_SOFT_PRODUCT_REQUEST", deleteSoftProductById);
  yield takeLatest("FETCH_PRODUCTS_BY_SHIPPER_REQUEST", getProductByIdShipper);
  yield takeLatest("UPLOAD_MASSIVE_PRODUCTS_FILE_REQUEST", uploadMassiveProductsFile);
  yield takeLatest("NOTIFY_PRODUCT_SHOPIFY_REQUEST", connectShopifyProduct);
}
